import React from 'react';
import { Paper } from '@src/components/reusable/Paper';
import styled from 'styled-components';

export const Overlay = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
`;

export const StyledPaper = styled(({ width, ...rest }) => <Paper {...rest} />)`
  width: 100%;
  max-width: ${({ width }) => `${width || 445}px`};
  padding: 24px;
  overflow-y: auto;
  max-height: 90vh;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const Title = styled('h2')`
  margin: 0;
  font-size: 23px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  color: #333333;
`;

export const IconButton = styled('button')`
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
